import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class ZavrseneEdukacijeService {

  constructor(private _http: Http) { }

  dohvatiZavrseneEdukacije(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_zavrsene_edukacije', a)
    .map(res => res.json()); 
  }

  kreiranje_syllabusa(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kreiranje_syllabusa', a)
    .map(res => res.json());
  }

  dohvati_idmodule_za_ucionicu(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_idmodule_za_ucionicu', a)
    .map(res => res.json());
  }
  
}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/zavrseneedukacije/zavrseneedukacije.service.ts